import {httpService} from "@/modules/common/services"


const getTodo = async () => {
  try {
    let result = await httpService.get('todo',{automatic: true})
    return result
  } catch (e) {
    return e.response.data
  }
}


export default {
  getTodo
};
